type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'Agency'
const nameSource = 'partnerships/agenciesUsers'
const namePageTitle = 'Agencies'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Agencies',
  to: '/partnerships/agenciesUsers',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/partnerships/agenciesUsers/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/partnerships/agenciesUsers/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/partnerships/agenciesUsers/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export enum AGENCY_USER_ROLE_ENUM {
  MASTER = 'MASTER',
  ATTENDANT = 'ATTENDANT'
}

export const AGENCY_USER_ROLE_MAP: Record<AGENCY_USER_ROLE_ENUM, string> = {
  MASTER: 'MASTER',
  ATTENDANT: 'ATENDENTE'
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
